module.exports = __webpack_public_path__ + "img/logo_alexion_pharmaceuticals.2d8a4613.png";